// App.js

import './App.css'
import Translator from './components/Translator'

function App() {
  return (
    <div className="App">
      <Translator />
    </div>
  )
}

export default App
